import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { verifyEmail, resendCode } from "../../redux/actions/authAction";
export default function VerifyEmail(props) {
  const {verifyEmailRes, emailVerified, isAuthenticated} = useSelector(state => state.authData)

  const {email_verify_token, id} = verifyEmailRes || {}
  const dispatch = useDispatch();
  let form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    const { otp } = form.current;
    let formdata = {
        otp: otp.value,
        email_verify_token: email_verify_token,
        id: id,
    };
    dispatch(verifyEmail(formdata));
  };

  const handleResendCode = () => {
    let data = {
      email_verify_token: email_verify_token,
      id: id,
  };
    dispatch(resendCode(data))
  }

  useEffect(() => {
     if(emailVerified) {
      props.history.push("/customers");
     }
  }, [emailVerified])

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/customers");
    }
  }, [isAuthenticated]);
  
  return (
    <div className="container-fluid userservice_section">
      <div className="row align-items-center">
        <div className="col-sm-12 login_part">
          <div className="clearfix registeraArea loginArea">
            <h1 className="form_title">Verify Email</h1>
            <form action="" className="form" ref={form} onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="user_form_label">Verification code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter verification code"
                  required
                  name="otp"
                />
                <p className="text-right fz12 mb-0 mt-2">Didn't receive the code? <span className="text-dark c-pointer font-weight-bold" onClick={handleResendCode}>Resend Code</span></p>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-dark submit-btn">
                  Verify Account
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
